@if (isOpenLayersMapImplementation) {
  <cue-open-layers-styles />
} @else {
  <cue-leaflet-styles />
}
@if (navigationDetail.value()) {
  <div class="breadcrumb-container breadcrumb-mobile" data-cy="breadcrumb-banner">
    @for (breadcrumb of navigationDetail.value().breadcrumbWithIds; track breadcrumb; let i = $index) {
      <span class="breadcrumb">
        @if (i !== 0) {
          <cue-icon [icon]="ICONS.cueArrowRight" />
        }
        <span class="part">{{ breadcrumb.item2 | localizedString }}</span>
      </span>
    }
  </div>
}
@if (isLoading()) {
  <cue-loading />
} @else if (!navigatable()) {
  <div class="flex h-full w-full items-center justify-center">
    <span class="text-neutral-500">{{ translation.multiview.navigationNotAvailable | transloco }}</span>
  </div>
} @else if (navigationConfiguration.hasValue()) {
  @if (selectedArea(); as area) {
    <cue-declarative-map-canvas
      [debug]="debug()"
      [zoom]="zoom()"
      [resetZoom]="area.zoomLevelDefault"
      [minZoom]="area.zoomLevelMin"
      [maxZoom]="area.zoomLevelMax"
      (zoomChanged)="zoom.set($event)"
    >
      <cue-declarative-map-image
        (imageLoaded)="imageIsSettingUp.set(false)"
        [fitMap]="!navigatable() || !focus()"
        [src]="areaMapSrc()"
        [width]="areaMapWidth()"
        [height]="areaMapHeight()"
      />

      @if (isResource() && resourceWithScheduleData()) {
        <cue-map-resource
          [fitMap]="true"
          [focused]="focus() === 'resource'"
          [reservable]="resourceWithScheduleData().schedules.availabilityView"
          [workingHourInfo]="
            resourceWithScheduleData().schedules?.resourceWorkingHours
              ? {
                  workingHours: resourceWithScheduleData().schedules.resourceWorkingHours,
                }
              : undefined
          "
          [geoJson]="resourceWithScheduleData().geometry"
          [radius]="resourceWithScheduleData().radius"
          [availability]="resourceWithScheduleData().schedules.availabilityView"
        />
      }

      @if (qrCodeGeo()) {
        <cue-declarative-map-marker
          className="'map-active-item'"
          [focused]="focus() === 'qr'"
          [geoJson]="qrCodeGeo().geometry"
        >
          <cue-floorplan-button
            (visibilityChanged)="focus.set($event ? (navigatable() ? 'qr' : null) : isResource() ? 'resource' : null)"
            *cueDeclarativeMapMarkerTemplate
            [class.map-active-item]="true"
            [floorplanDataItem]="qrCodeGeo()"
            [zoomLevel]="zoom()"
            [isActiveItem]="true"
            [smallResponsiveAllways]="true"
            [customResizeBasedOnZoomEnabled]="qrCodeGeo().zoomPoi"
            [sizeCoefficient]="qrCodeGeo().poiSize"
          />
        </cue-declarative-map-marker>
      }
    </cue-declarative-map-canvas>

    <div class="buttons">
      @if (canBeSetAsStart()) {
        <button cue-button size="small" class="xs-font-small" (click)="selectAsStart()">
          <cue-icon [icon]="ICONS.cueStart" />
          {{ translation.navigation.selectAsStart | transloco }}
        </button>
      }
      @if (canBeSetAsTarget()) {
        <button cue-button size="small" class="xs-font-small" (click)="navigateTo()">
          <cue-icon [icon]="ICONS.cueTarget" />
          {{ translation.navigation.navigateTo | transloco }}
        </button>
      }
    </div>
  }
}
